const PUBLIC_CUSTOMER_PATH_PREFIXES = ['/t/', '/o/', '/feedback/', '/tilbud']

export function isPublicCustomerPath(pathname) {
  return PUBLIC_CUSTOMER_PATH_PREFIXES.some(prefix => pathname.startsWith(prefix))
}
